interface WishlistLastUsed {
  id: string
  name: string
}

export interface WishlistItem {
  code: string
}
export interface WishlistEvent extends WishlistItem {
  editMode?: boolean
}

export function useWishlist() {
  const localStorage = useLocalStorage<WishlistLastUsed | undefined>(
    'lastUsedWishlist',
    { id: '', name: '' },
    { serializer: useObjectStorageSerializer() },
  )
  const addEventBus = useEventBus<WishlistEvent>('addToWishlist')
  const deleteEventBus = useEventBus<WishlistEvent>('deleteFromWishlist')

  function toggle({ code }: WishlistItem, state: boolean) {
    if (state) {
      addEventBus.emit({ code })
    } else {
      deleteEventBus.emit({ code })
    }
  }

  function edit({ code }: WishlistItem) {
    addEventBus.emit({ code, editMode: true })
  }

  return {
    lastUsed: localStorage,
    addEventBus,
    deleteEventBus,
    toggle,
    edit,
  }
}
